import React, { Component } from 'react';
import { func, number, string, bool } from 'prop-types';
import Input from 'ps-components/Input/Input';
import './SetPercentInput.scss';

class SetPercentInput extends Component {
  static propTypes = {
    column: string,
    percent: number,
    setRangePctValue: func,
    isDisabled: bool
  };

  render() {
    const { column, percent, setRangePctValue } = this.props;
    let formattedPercent;
    if (percent % 1 === 0) {
      formattedPercent = percent;
    } else {
      formattedPercent = Number(Math.round(percent + 'e' + 2) + 'e-' + 2);
    }

    const inputClass = this.props.isDisabled
      ? 'range__percent-input range__percent-input-disabled'
      : 'range__percent-input';

    return (
      <div className="percent__input-container">
        <Input
          className={inputClass}
          id={`${column}__range-pct`}
          onChange={setRangePctValue}
          type="number"
          value={this.props.isDisabled ? '' : formattedPercent || 0}
          disabled={this.props.isDisabled}
        />
        <span>%</span>
      </div>
    );
  }
}

export default SetPercentInput;
